<template>
  <div class="publicScore">
    <img class="logoImg" :src="logo">
    <h1>成绩查询系统</h1>
    <section style="min-height: 320px">
      <van-field ref="idNumber" v-model="cert.idNumber" maxlength="18" label="身份证号" placeholder="请输入身份证号" />
      <van-button :style="{ backgroundColor: color, border: '0.02667rem solid' + color }" type="primary" size="large" :loading="loading" :disabled="loading" loading-text="查询中..." @click="submit">立即查询</van-button>
    </section>
    <div class="footer">
      <p>北京阿叟阿巴科技有限公司</p>
      <p>ALSOLIFE 2017 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import { Toast, Field, Button } from 'vant'
import { getUserScore } from '../../api/certAndScore'

export default {
  name: 'PublicScore',
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    logo: { // Logo图片
      type: String,
      default: ''
    },
    type: { // 查询成绩的证书类型
      type: String,
      default: ''
    },
    color: { // 按钮颜色
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: '',
      loading: false,
      cert: {
        idNumber: ''
      },
      result: []
    }
  },
  created () {
    localStorage.removeItem('ScoreResultNum')
  },
  mounted () {},
  methods: {
    submit() {
      let that = this
      if (that.cert.idNumber != '') {
        that.loading = true
        getUserScore({
          idNumber: that.cert.idNumber,
          type: that.type
        }).then(function(res) {
          that.loading = false
          if (res.status == 200) {
            that.result = res.business
            that.$router.push({ name: 'resultScore', query: { result: JSON.stringify(that.result), color: that.color } })
          } else {
            Toast.fail(res.status == 400 ? '查询为空' : '查询失败')
          }
        })
          .catch(function(error) {
            that.loading = false
            Toast.fail('网络出现错误\n请稍后重试' || error)
          })
      } else {
        Toast('\n身份证号输入框不能为空\n请输入身份证号\n\n')
        that.$refs.idNumber.focus()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.publicScore {
  .logoImg{ // logo图片
    margin: 10vw auto 0;
    width: auto;
    height: 40vw;
    display: block;
  }
	h1 { // 成绩查询系统的标题
		font-size: 20px;
		text-align: center;
		margin-bottom: 10vw
	}
	section {
		padding: 10px;
		margin-bottom: 10vw
	}
  ::v-deep .van-button { // 立即查询按钮
    margin-top: 10vw;
  }
  .footer { // 底部版权
    padding-bottom: 10vw;
    p {
      font-size: 12px;
      text-align: center;
      color: rgba(0, 0, 0, .4);
    }
	}
}
</style>